<template>
  <BaseModal ref="modal">
    <UiModalDialog class="jps-image-upload-modal">
      <template #header>
        <BaseIcon name="mdi/upload" />
        {{ ls({ ja: 'コマの選択', en: 'Select Image' }) }}
      </template>
      <div class="jps-modal-content">
        <ClientOnly>
          <UiIiifViewer :image="image" @url="setUrl" />
        </ClientOnly>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.cancel) }}</button>
        <button @click="confirm()">確定</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { BaseModal } from '#components'

const { ls } = useI18n()

interface Props {
  manifestUrl?: string
}
const props = withDefaults(defineProps<Props>(), {
})

const modal = ref<InstanceType<typeof BaseModal>>()
const _manifestUrl: Ref<string> = ref('')
const openAwait = async (options?: Props) => {
  url.value = null
  setOptionsValue(_manifestUrl, 'manifestUrl', props, options, '')
  return await modal.value.openAwait<string>()
}
defineExpose({ openAwait })

const url: Ref<string> = ref(null)

const setUrl = (_url) => {
  url.value = _url
}

const image = computed<ViewerInfo>(() => {
  return {
    type: 'MANIFEST',
    url: _manifestUrl.value,
  }
})

const confirm = () => {
  modal.value.resolve(url.value)
}
</script>

<style lang="scss" scoped>
.jps-image-upload-modal {
}
</style>
